'use client'

import useBlogList from '../../../../core/hook/useBlogList'
import { buildFullUrlMedia } from '../../../../core/hook/utils'
import { BLOG_TYPE_EVENT, CmsBlogList, PAGE_SIZE_FOR_RUBRIC } from '../../../../domain/cmsBlogList'
import { useTranslation } from '../../../context/ConfigContext'
import AnimationEventOnBlogList from './AnimationEventOnBlogList'
import StickyYearOnBlogList from './StickyYearOnBlogList'
import Image from '../../Image/Image'
import Link from '../../Link/Link'
import clsx from 'clsx'

const BlogEventList = ({ initialData }: { initialData: CmsBlogList }) => {
  const { data, isLoading, fetchNextPage, isLastPage, page } = useBlogList(
    { blogType: BLOG_TYPE_EVENT, pageSize: PAGE_SIZE_FOR_RUBRIC[BLOG_TYPE_EVENT] },
    initialData,
  )
  const t = useTranslation()

  return (
    <div className='Blog-list-container'>
      <StickyYearOnBlogList isReady={!isLoading} />
      {data.items.map((item) => (
        <article
          key={item.id}
          className='Blog-list-item Blog-item with-event-item-animation'
          data-year={item.date?.getFullYear() ?? null}
          data-id={item.id}>
          <div className='Blog-item-wrapper'>
            <Link href={item.url}>
              <div className='Blog-item-image Item--4_3'>
                <div className='content-wrapper content-wrapper-event'>
                  <picture>
                    <Image
                      className='img-responsive'
                      src={buildFullUrlMedia(`/media/${item.image}`)}
                      alt={item.name}
                    />
                  </picture>
                </div>
              </div>
              <div className='Blog-item-info-wrapper'>
                <h2 className='Blog-item-title'>{item.name}</h2>
                <div className='Blog-item-date'>{item.date?.toLocaleDateString()}</div>
                <div
                  className='Blog-item-description'
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              </div>
            </Link>
          </div>
        </article>
      ))}
      {!isLastPage && (
        <div className='event-page-container-seemore'>
          <a
            href={`?page=${page}`}
            className={clsx('button white', { 'button--loading': isLoading })}
            onClick={(e) => {
              e.preventDefault()
              e.nativeEvent.stopImmediatePropagation()
              e.currentTarget.blur()
              fetchNextPage()
            }}>
            <span className='snake' />
            <span className='snake__overlay' />
            {t('See more', {}, false)}
          </a>
        </div>
      )}
      <AnimationEventOnBlogList items={data.items} classNameItem='with-event-item-animation' />
    </div>
  )
}

export default BlogEventList
